module.exports = __webpack_public_path__ + "static/media/banner.8b3cae14.png";